export const Props = () => ({
  //--------------------------------------------------------------------------
  //              Модификатор для выбора внешнего вида тега
  //--------------------------------------------------------------------------
  type: {
    type: String,
    default: 'default',
    validator: (value) => {
      const allowedTypes = ['default', 'pale'];
      if(allowedTypes.includes(value)){
        return true;
      } else{
        throw new Error(`Параметр 'type' в компоненте Tag Value может содержать только значения: ${allowedTypes.join(', ')}`);
      }
    }
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});